import { DagreSettings } from "../services/layout/dagreNodesOnly";
import { EdgePointerType, EEdgyType, ELayoutAlgorithms } from "./graph-kn.model-enums";
import {IGraphNode, NodeDimension, NodePosition, TAttachmentType, TNodeStatus} from "./graph-kn.model-interfaces";

export const CONTRACT_LAYER_ID = 'contractLayer'
export const BUSINESS_PROCESS_LAYER_ID = 'bpLayer'
export type TLayerIDs = typeof CONTRACT_LAYER_ID | typeof BUSINESS_PROCESS_LAYER_ID
export type TNodeTypes = 'BPStatus'|'TaskStep'|'childBPStatus'|'parentBP'|'subContractStep'|'contractStep'
export type TIconsType =
    'ADD_NODE'
    | 'VIEW_NODE'
    | 'ADD_EDGE'
    | 'COMPLETED_STEP'
    | 'COMPLETED_TARGET'
    | 'CLOSE_ICON'
    | 'ACTIVE_STEP'
    | 'DELETE_NODE'
    | 'EDIT_NODE'
    | 'ADD_INFO'
    | 'ADD_NODE_STEP'
    | TNodeStatus
    | TAttachmentType
export const CONTRACT_GRAPH_TYPES = ['line', 'stairs', 'fading_strairs'] as const
export type TContractGraphType = (typeof CONTRACT_GRAPH_TYPES)[number]

export interface DagreNodesOnlySettings extends DagreSettings {
    curveDistance?: number;
    width?: number,
    heigt?: number,
    offsetY?: number,
    fill?: string,
    parent?: boolean
    moveAlg?: 'save' | 'calc',
    nodeWidthAdaptive?: boolean,
    layoutModel?: TContractGraphType,
    edgeType?: EEdgyType,
    pointerType?: EdgePointerType,
    algorithmEdges?:ELayoutAlgorithms,
    module?:ELayoutAlgorithms
}

export interface INodeChangeEvent {
    action: TIconsType,
    data: IGraphNode,
    canEdit: boolean,
    pureAction?: boolean
}

export interface IStageSettings {
    offsetX?: number | 0,
    offsetY?: number | 0,
    width?: number,
    height?: number,
    draggable?: boolean | true,
    contextMenu?: boolean
    showSettingsButton?: boolean,
}

export interface IKnUIOptions {
    draggable?:boolean,
    closeLayerButton?:boolean
    showDetails?: boolean,
    showUsers?: boolean,
    showStatusPanel?: boolean,
    showEdit?: boolean,
    showView?: boolean,
    showDelete?: boolean,
    showDeleteEdge?: boolean,
    showCreateNode?: boolean,
    showCreateEdge?: boolean,
}
export interface IKnGraphSettings {
    layoutAlgorithm?: ELayoutAlgorithms ,
    edgeType?: EEdgyType,
    edgePointerType?: EdgePointerType,
}

export enum Orientation {
    LEFT_TO_RIGHT = 'LR',
    RIGHT_TO_LEFT = 'RL',
    TOP_TO_BOTTOM = 'TB',
    BOTTOM_TO_TOM = 'BT'
}
export enum Alignment {
    CENTER = 'C',
    UP_LEFT = 'UL',
    UP_RIGHT = 'UR',
    DOWN_LEFT = 'DL',
    DOWN_RIGHT = 'DR'
}
export interface Node {
    id: string;
    position?: NodePosition;
    dimension?: NodeDimension;
    transform?: string;
    label?: string;
    data?: any;
    meta?: any;
    layoutOptions?: any;
    parentId?: string;
    hidden?: boolean;
}